import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class MAX30105Extension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'max30105',
            name: formatMessage({
                id: 'gui.extension.max30105.name',
                default: 'Heart Rate Sensor'
            }),
            color1: '#E91E63', // Pink/Red color for Heart Rate
            color2: '#D81B60',
            color3: '#C2185B',
            
            arduinoDependencies: ['SparkFun MAX3010x Pulse and Proximity Sensor Library'],

            blocks: [
                {
                    opcode: 'init',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'max30105.blocks.init',
                        default: 'initialize heart rate sensor'
                    })
                },
                {
                    opcode: 'getIR',
                    blockType: 'reporter',
                    text: formatMessage({
                        id: 'max30105.blocks.getIR',
                        default: 'read IR value'
                    })
                },
                {
                    opcode: 'getRed',
                    blockType: 'reporter',
                    text: formatMessage({
                        id: 'max30105.blocks.getRed',
                        default: 'read red value'
                    })
                }
            ],

            codeTemplates: [
                {
                    opcode: 'init',
                    type: 'command',
                    arduino: {
                        code: '', // It just sets up in setup()
                        setup: [
                            'if (!particleSensor.begin(Wire, I2C_SPEED_FAST)) { Serial.println("MAX30105 not found"); while(1); }',
                            'particleSensor.setup(60, 4, 2, 100, 411, 4096);'
                        ],
                        includes: ['#include <Wire.h>', '#include "MAX30105.h"'],
                        declarations: ['MAX30105 particleSensor;']
                    }
                },
                {
                    opcode: 'getIR',
                    type: 'reporter',
                    arduino: {
                        code: 'particleSensor.getIR()'
                    }
                },
                {
                    opcode: 'getRed',
                    type: 'reporter',
                    arduino: {
                        code: 'particleSensor.getRed()'
                    }
                }
            ]
        };
    }

    // VM simulation handlers for preview
    init () {}
    
    getIR () {
        return 115000 + Math.floor(Math.random() * 5000);
    }

    getRed () {
        return 110000 + Math.floor(Math.random() * 5000);
    }
}

export default MAX30105Extension;
